module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/axios/index.js
// module id = 550
// module chunks = 0